import { render, staticRenderFns } from "./services-popular.vue?vue&type=template&id=177dcb96&scoped=true"
import script from "./services-popular.vue?vue&type=script&lang=js"
export * from "./services-popular.vue?vue&type=script&lang=js"
import style0 from "./services-popular.vue?vue&type=style&index=0&id=177dcb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177dcb96",
  null
  
)

export default component.exports